
import api from './api';

const endpoint = '/api/cancelamentos';

const CancelamentosService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  cancelarPublico: async (payload) => {
    return api.post(endpoint, payload);
  },

  cancelarAdmin: async (payload) => {
    return api.post(`${endpoint}/admin`, payload);
  },

};

export default CancelamentosService;